const tmStyle = {
fontSize: '0.5em',
verticalAlign: 'super'
};

const products = [
  {
    id: 'largedragonegg',
    name: 'Large Dragon Egg',
    shortDesc: 'It has waited centuries for this moment',
    heroImage: '/Graphics/Product Screenshots/LaunchingSoon.png',
    screenshots: [
      '/Graphics/Product Screenshots/LaunchingSoon.png',
    ],
    
    description: `This majestic-looking egg definitely might hatch into a dragon. Or it could just sit there being mysterious and scaly forever. We haven’t dared tap it too hard — last intern who tried now smells faintly of brimstone. Until we figure out what’s inside, feel free to admire its vaguely threatening aura and decorative potential.`,
    price: 0.00,
    stripeLink: ""
  },
  {
    id: 'smalldragonegg',
    name: 'Small Dragon Egg',
    shortDesc: 'A quiet presence with ancient intent',
    heroImage: '/Graphics/Product Screenshots/LaunchingSoon.png',
    screenshots: [
      '/Graphics/Product Screenshots/LaunchingSoon.png',
    ],
    
    description: `It’s like the big one, but sneakier. This small dragon egg still hasn’t hatched, but it wiggles suspiciously when no one’s watching. Probably nothing. Probably. Great for shelves, desks, and subtly asserting dominance over lesser mythical trinkets.`,
    price: 0.00,
    stripeLink: ""
  },
  {
    id: 'largedragon',
    name: 'Large Articulated Dragon',
    shortDesc: 'Born of legend, destined to command',
    heroImage: '/Graphics/Product Screenshots/LaunchingSoon.png',
    screenshots: [
      '/Graphics/Product Screenshots/LaunchingSoon.png',
    ],
    
    description: `Larger, loungier, and absolutely convinced it owns your entire desk. This majestic creature is fully articulated and ready to coil, sprawl, or strike intimidating poses on command (or whim). Not recommended as a pillow. Trust us.`,
    price: 0.00,
    stripeLink: ""
  },
  {
    id: 'smalldragon',
    name: 'Small Articulated Dragon',
    shortDesc: 'Forged in myth, now ready to stretch its wings',
    heroImage: '/Graphics/Product Screenshots/LaunchingSoon.png',
    screenshots: [
      '/Graphics/Product Screenshots/LaunchingSoon.png',
    ],
    
    description: `Don't let the size fool you — this little beast packs maximum attitude per scale. Fully articulated, mildly judgmental, and prone to dramatic poses. May guard USB sticks, shiny objects, or your snacks. No fire breath detected… yet.`,
    price: 0.00,
    stripeLink: ""
  }
];

export default products;
